<template>
    <v-container>
        <v-alert :value="showPrivacyNotice" type="info" icon="fingerprint" class="mb-3">
            <h4>Privacy</h4>
            <p>
                Op de meeste Android telefoons is het mogelijk een vingerafdruk of pincode te gebruiken in deze demo.
                Door de techniek achter deze demo kunnen we <u>onmogelijk</u> je pincode
                achterhalen of een afbeelding maken van je vingerafdruk.
                Beveiliging van zulke gevoelige persoonsgegevens is een groot voordeel van deze manier van inloggen.
            </p>
            <v-btn @click="showPrivacyNotice = false" flat dark class="pl-0 ml-0">
                Ok, ik begrijp het
            </v-btn>
        </v-alert>

        <h3>Gebruikers</h3>
        <v-btn fab fixed bottom right icon dark color="primary" @click="onAddPersonClick">
            <v-icon>person_add</v-icon>
        </v-btn>
        <template v-if="users.all.length">
            <p>Klik op de naam om het inloggen te testen.</p>
            <v-list>
                <v-list-tile ripple v-for="user in users.all" :key="user.username" @click="onLoginUserClick(user)">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ user.username }}
                            <v-icon color="success" v-if="user.loginSuccess">
                                checkmark
                            </v-icon>
                        </v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-btn icon @click="onDeleteUserClick(user)">
                            <v-icon color="danger">
                                delete
                            </v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </template>
        <template v-else>
            <p>Klik op de knop rechtsonderin om een nieuwe gebruiker te registreren.</p>
        </template>

        <v-dialog v-model="registerModal" fullscreen scrollable>
            <register-screen @close="registerModal = false" v-if="registerModal" />
        </v-dialog>

        <v-dialog v-model="loginModal">
            <login-screen @close="loginModal = false" v-if="loginModal" :username="loginUserName" />
        </v-dialog>
    </v-container>
</template>

<script>
import users from './WebAuthn/users'
import RegisterScreen from './WebAuthn/RegisterScreen'
import LoginScreen from './WebAuthn/LoginScreen'

export default {
    components: {
        RegisterScreen,
        LoginScreen,
    },
    data () {
        return {
            users,
            registerModal: false,
            loginModal: false,
            loginUserName: null,
            showPrivacyNotice: true,
        }
    },
    methods: {
        onDeleteUserClick (user) {
            this.users.delete(user.username)
        },
        async onAddPersonClick () {
            this.registerModal = true
            // console.log(await client.register('Harrie', 'cross-platform'))
        },
        onLoginUserClick (user) {
            this.loginModal = true
            this.loginUserName = user.username
        },
    },
}
</script>
